import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { ToastContainer } from "react-toastify";
import { connect } from "react-redux";
import Routes from "../config/Routes";
import { getUser, refreshToken } from "../store/actions/authActions";
import ModalContainer from "../common/modals/ModalContainer";
import { getFechaExpiracionToken, getJwt } from "../config/auth/credentialConfiguration";
import LoadingComponent from "./LoadingComponent";
import { createMedia } from "@artsy/fresnel";
import { useRef } from "react";
import { useUserActivity } from "../hooks/useUserActivity";

const actions = {
  getUser,
  refreshToken
};

//Media
const AppMedia = createMedia({
  breakpoints: {
    mobile: 280, //320 standard
    tablet: 768,
    computer: 992,
    largeScreen: 1200,
    widescreen: 1920,
  },
});

const mediaStyles = AppMedia.createMediaStyle();

const { Media, MediaContextProvider } = AppMedia;

const App = ({ getUser, refreshToken }) => {

  const token = getJwt();

  const [appLoaded, setAppLoaded] = useState(false);

  const lastActivityRef = useRef(Date.now());

  const handleActivity = () => { lastActivityRef.current = Date.now(); };

  useUserActivity(handleActivity);

  useEffect(() => {
    const interval = setInterval(() => {

      const expirationDate = getFechaExpiracionToken();

      const currentToken = localStorage.getItem('token');

      if (!expirationDate || !currentToken) return;

      const now = Date.now();

      const expiresInMs = expirationDate.getTime() - now;

      const timeSinceLastActivity = now - lastActivityRef.current;

      const REFRESH_THRESHOLD = 2 * 60 * 1000; // 2 minutos antes de expirar

      if (expiresInMs < REFRESH_THRESHOLD && timeSinceLastActivity < REFRESH_THRESHOLD) refreshToken();

    }, 60 * 1000); // check cada 1 minuto

    return () => clearInterval(interval);

  }, [token]);

  useEffect(() => {
    if (token) getUser().finally(() => setAppLoaded(true));
    else setAppLoaded(true);
  }, [getUser, token]);

  if (!appLoaded) return <LoadingComponent content="Cargando Prymera Digital.." />;

  return (
    <>
      <ModalContainer />
      <ToastContainer position="top-right" />
      <Routes
        mediaStyles={mediaStyles}
        Media={Media}
        MediaContextProvider={MediaContextProvider}
      />
    </>
  );

};

App.propTypes = {
  getUser: PropTypes.func.isRequired,
  refreshToken: PropTypes.func.isRequired
};

export default connect(null, actions)(App);
